function onlyNumbers(value) {
  if (!value) {
    return null;
  }
  if (!value.match(/\d+/g)) {
    return null;
  }
  return value.match(/\d+/g).join('');
}

function hasAnyLetter(text) {
  if (!text) {
    return false;
  }
  return text.match(/[a-zA-Z]/g);
}

function formatCnpj(cnpj) {
  if (!cnpj) {
    return '';
  }
  if (cnpj.match(/\d+/g)) {
    return cnpj.match(/\d+/g).join('');
  }
  return cnpj;
}
export {
  formatCnpj,
  onlyNumbers,
  hasAnyLetter,
};
